import React from "react"
import * as s from "./SkipLink.module.scss"

export const SkipLink = () => {
  return (
    <a href="#main-content" className={s.SkipLink}>Skip to main content</a>
  )
}